import { useTranslation } from 'react-i18next'
import { stageSelector } from 'models/battle/selectors'
import { useSelector, useDispatch } from 'react-redux'
import { CSSTransition } from 'react-transition-group'
import { stageType } from '../constants/stageType'
import { setStage } from 'models/battle/actions'

import c from './assets/sass/panel.module.scss'

export const Panel = () => {
    const { t } = useTranslation()
    const stage = useSelector(stageSelector)
    const dispatch = useDispatch()

    const handlePlayAgain = () => {
        dispatch(setStage(stageType.betting))
    }

    return (
        <div className={c.component}>
            <CSSTransition
                in={stage === stageType.rolling}
                timeout={300}
                classNames={{
                    enter: c.enter,
                    enterActive: c.enterActive,
                    exit: c.exit,
                    exitActive: c.exitActive,
                }}
                unmountOnExit
            >
                <div className={c.loading}>
                    <div className={c.loader} />
                    <span>{t('battle.panel.selecting')}</span>
                </div>
            </CSSTransition>
            <CSSTransition
                in={stage === stageType.finished}
                timeout={300}
                classNames={{
                    enter: c.enter,
                    enterActive: c.enterActive,
                    exit: c.exit,
                    exitActive: c.exitActive,
                }}
                unmountOnExit
            >
                <button className={c.button} onClick={handlePlayAgain}>
                    <span>{t('battle.panel.playAgain')}</span>
                </button>
            </CSSTransition>
        </div>
    )
}
